import React from 'react';

import * as s from './styles.scss';

const Navbar = () => (
  <div className={s.nav}>
    <img src="/static/logoWhite.svg" alt="logo" />
    <p>
      <span>Need some help?</span>
      &nbsp;Talk to an accountant:{' '}
      <a href="tel:+1-801-682-1204">(801) 682-1204</a>
    </p>
  </div>
);

export default Navbar;
